export default __webpack_public_path__ + "static/media/hypergate_iseo.ae547fcb.png";